/**
 * Чиби-иконки (ISSUE-114): один атлас `ui-icons.webp`, сетка и имена — `chibi-icons.json` (сборка `tools/ui-art/pack.mjs`).
 * Рисуются фоном: картинку грузит браузер при первой иконке, до неё место пустое. Иконки без записи в карте остаются
 * прежними — так новое усиление без арта не ломает окно.
 */
import type { JSX } from "preact";
import map from "./chibi-icons.json";
import heroMap from "./hero-portraits.json";
import "./chibi-icons.css";
import type { IconRenderer } from "./icons";

const NAMES: Readonly<Record<string, readonly number[]>> = map.names;

const percent = (i: number, n: number): string => `${n > 1 ? (i * 100) / (n - 1) : 0}%`;

const HERO_NAMES: Readonly<Record<string, readonly number[]>> = heroMap.names;

/** Иконка из атласа или `null`, если такой нет. Портреты героев беты (`hero_*`) — из своего атласа `hero-portraits`. */
export function chibiIcon(name: string): JSX.Element | null {
  const hero = HERO_NAMES[name];
  const at = hero ?? NAMES[name];
  const grid = hero ? heroMap : map;
  if (!at) return null;
  return (
    <span
      class={hero ? "kit-icon__art kit-icon__art--hero" : "kit-icon__art"}
      style={{
        backgroundSize: `${grid.cols * 100}% ${grid.rows * 100}%`,
        backgroundPosition: `${percent(at[0] ?? 0, grid.cols)} ${percent(at[1] ?? 0, grid.rows)}`,
      }}
    />
  );
}

export const chibiIconRenderer: IconRenderer = (name) => chibiIcon(name);
